/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Attributes_To_ReviewInputs */

const en_queue_attributes_to_review = /** @type {(inputs: Queue_Attributes_To_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attributes to review`)
};

/**
* | output |
* | --- |
* | "Attributes to review" |
*
* @param {Queue_Attributes_To_ReviewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_attributes_to_review = /** @type {((inputs?: Queue_Attributes_To_ReviewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Attributes_To_ReviewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_attributes_to_review(inputs)
});